<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '24',
	},
	height: {
		type: String,
		default: '24',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 49 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="google">
			<path
				id="vector"
				d="M45.7511 24.4661C45.7511 22.7395 45.6081 21.4795 45.2987 20.1729H25.1797V27.9661H36.9891C36.7511 29.9028 35.4654 32.8195 32.6082 34.7794L32.5681 35.0403L38.9294 39.8697L39.3701 39.9128C43.4177 36.2495 45.7511 30.8594 45.7511 24.4661Z"
				fill="#4285F4"
			/>
			<path
				id="vector_2"
				d="M25.178 45.0002C30.9636 45.0002 35.8207 43.1334 39.3684 39.9134L32.6065 34.7799C30.797 36.0166 28.3684 36.88 25.178 36.88C19.5114 36.88 14.7019 33.2167 12.9875 28.1533L12.7362 28.1742L6.12166 33.191L6.03516 33.4266C9.55892 40.2866 16.797 45.0002 25.178 45.0002Z"
				fill="#34A853"
			/>
			<path
				id="vector_3"
				d="M12.9919 28.1534C12.5395 26.8468 12.2777 25.4467 12.2777 24.0001C12.2777 22.5533 12.5395 21.1534 12.9681 19.8467L12.9561 19.5685L6.25869 14.4712L6.03956 14.5733C4.58725 17.42 3.75391 20.6168 3.75391 24.0001C3.75391 27.3834 4.58725 30.58 6.03956 33.4267L12.9919 28.1534Z"
				fill="#FBBC05"
			/>
			<path
				id="vector_4"
				d="M25.1781 11.1199C29.2019 11.1199 31.9161 12.8233 33.4638 14.2467L39.5114 8.46C35.7972 5.07668 30.9637 3 25.1781 3C16.7971 3 9.55894 7.7133 6.03516 14.5732L12.9637 19.8466C14.702 14.7833 19.5115 11.1199 25.1781 11.1199Z"
				fill="#EB4335"
			/>
		</g>
	</svg>
</template>
